<div class="access-denied-container">
  <h1>We cannot connect you</h1>
  <p>You do not have access to the Order Management Tool.</p>
  {{ date | date : 'long' }}
</div>
